var isNull = function (value) {
  return value === null;
};

export default isNull;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-null.js
// module id = 86
// module chunks = 0